export default function Bug() {
  return (
    <div
      className="ion-icon-bug"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M374.64,127.327C345.365,88.512,303.062,64,256,64s-89.365,24.512-118.64,63.327c6.354,15.64,15.833,30,28.13,42.297
		c24.176,24.176,56.319,37.49,90.51,37.49s66.334-13.314,90.51-37.49C358.807,157.327,368.286,142.966,374.64,127.327z"/>
	<path d="M126.836,142.824c-1.725,2.827-3.396,5.703-4.992,8.644c-2.926-1.84-5.319-3.74-7.745-5.773
		c-1.171-0.981-2.954-3.949-4.546-7.35c5.41-11.314,1.181-25.037-9.914-31.261c-11.561-6.484-26.188-2.372-32.674,9.189
		c-6.485,11.56-2.371,26.188,9.187,32.673c1.251,0.702,2.539,1.272,3.847,1.729c2.816,6.269,7.32,14.331,13.548,19.547
		c4.184,3.507,8.792,7.117,15.204,10.674c-7.195,20.259-11.576,42.303-12.545,65.427c-11.026,0.207-18.619,2.1-25.474,4.122
		c-4.16,1.227-8.192,3.395-11.823,5.852c-0.954-0.115-1.923-0.182-2.908-0.182c-13.255,0-24,10.745-24,24s10.745,24,24,24
		c12.93,0,23.467-10.227,23.976-23.032c5.046-1.482,9.888-2.659,17.095-2.774c3.167,33.015,13.304,63.483,28.613,89.224
		c-14.166,11.006-22.882,23.016-26.605,36.317c0,0-0.75,0.438-1.873,1.366c-0.982,0.794-1.932,1.65-2.804,2.619
		c-8.865,9.855-8.062,25.031,1.793,33.895c9.854,8.865,25.028,8.062,33.893-1.793c8.087-8.988,8.095-22.381,0.558-31.395
		c3.074-5.562,6.236-9.014,13.67-14.961C171.368,425.235,207.723,445.619,248,448V222.872
		C194.764,219.954,149.229,188.138,126.836,142.824z"/>
	<path d="M456,256.114c-0.985,0-1.954,0.066-2.908,0.182c-3.631-2.457-7.663-4.625-11.823-5.852
		c-6.854-2.021-14.447-3.915-25.474-4.122c-0.969-23.125-5.35-45.168-12.545-65.427c6.412-3.557,11.021-7.167,15.204-10.674
		c6.228-5.216,10.731-13.278,13.548-19.547c1.308-0.458,2.596-1.028,3.847-1.729c11.558-6.485,15.672-21.114,9.187-32.673
		c-6.485-11.561-21.113-15.673-32.674-9.189c-11.095,6.225-15.324,19.947-9.914,31.261c-1.592,3.401-3.375,6.369-4.546,7.35
		c-2.426,2.033-4.819,3.933-7.745,5.773c-1.596-2.941-3.268-5.817-4.992-8.644c-22.393,45.314-67.928,77.13-121.164,80.048V448
		c40.277-2.381,76.632-22.765,103.686-54.42c7.434,5.947,10.596,9.399,13.67,14.961c-7.537,9.014-7.529,22.406,0.558,31.395
		c8.864,9.855,24.038,10.658,33.893,1.793c9.854-8.863,10.658-24.039,1.793-33.895c-0.872-0.969-1.821-1.825-2.804-2.619
		c-1.123-0.929-1.873-1.366-1.873-1.366c-3.724-13.302-12.439-25.312-26.605-36.317c15.31-25.74,25.446-56.209,28.613-89.224
		c7.207,0.115,12.049,1.292,17.095,2.774c0.509,12.806,11.046,23.032,23.976,23.032c13.255,0,24-10.745,24-24
		S469.255,256.114,456,256.114z"/>
</g>
</svg>
`,
      }}
    />
  )
}
